import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import './plugins/axios'
import vueDebounce from 'vue-debounce'
import VuePrintNb from 'vue-print-nb'
import router from './router'
import store from './store'
import App from './App.vue'

// Branding Plugin
import { BrandingPlugin, initBranding } from './plugins/branding'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import './registerServiceWorker'

// Import validation rules
import '@/utils/validation'

// Import brand global styles
import '@/assets/scss/brand-globals.scss'
import 'vue-select/dist/vue-select.css'
import 'vue2-editor/dist/vue2-editor.css'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(vueDebounce, {
  listenTo: ['input', 'keyup'],
})
// Composition API
Vue.use(VueCompositionAPI)

// Use Branding Plugin
Vue.use(BrandingPlugin)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.use(VuePrintNb)

Vue.config.productionTip = false

// Initialize branding before mounting app
initBranding().then(() => {
  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app')
}).catch(error => {
  // eslint-disable-next-line no-console
  console.error('[Branding] Initialization failed:', error)
  // Mount app anyway with defaults
  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app')
})
